module.exports = __webpack_public_path__ + "static/img/C4D0040.0dd029b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0040.jpg
// module id = 4bVw
// module chunks = 0